import { updateAdminAccountProfile } from 'api/adminAccounts';
import type { TUpdateAdminAccountProfileRequest } from 'types';

import {
  useUpdateAdminAccountBase,
  type UseUpdateAdminAccountResult,
  type UseUpdateAdminAccountOptions,
} from './useUpdateAdminAccountBase';

export function useUpdateAdminAccountProfile(
  options: UseUpdateAdminAccountOptions = {},
): UseUpdateAdminAccountResult<TUpdateAdminAccountProfileRequest> {
  return useUpdateAdminAccountBase<TUpdateAdminAccountProfileRequest>(
    updateAdminAccountProfile,
    options,
  );
}
